import { Injectable } from '@angular/core';
import { GlobalService } from '../global/global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
const headers = new HttpHeaders()
  .set("Auth-Key", "ba989509ad560f3ee2427ed27fa86a5d")
  .set("Client-Service", "univate-training");
@Injectable({
  providedIn: 'root'
})
export class RecruiterService {
  private url = GlobalService.serverURL + 'recruiter/';
  private expUrl = this.url + 'experience'
  private bankUrl = this.url + 'bank/'
  private profileUrl = this.url + 'job_profile/'
  private notesUrl = this.url + 'notes/'
  private categoryUrl = this.url + 'manage_category'
  private visaUrl = this.url + 'manage_visa/'
  private replacementUrl = this.url + 'manage_replacement/'
  private jobAccept = this.url + 'job_accept/'
  private empFavorite = this.url + 'employee_favourite/'
  private report = this.url + 'report/'
  private manageEvent = this.url + 'manage_event/'
  private manageTask = this.url + 'manage_task/'
  private employeeTimeLog = this.url + 'Employee_time_log/'
  private manageConflicts = this.url + 'manage_conflict/'

  constructor(
    private http: HttpClient,
  ) { }
  list(data: any) {
    return this.http.post(this.url + 'listing', data, { headers })
  }
  getCompanyList(data: any) {
    return this.http.post(this.url + 'company_list/list', data, { headers })
  }
  getDetails() {
    return this.http.get(this.url + 'job/get_recruiter_company_apply', { headers })
  }
  getClientCompanyDetails(data: any) {
    return this.http.post(this.url + 'direct_access', data, { headers })
  }
  inviteRecruiter(data: any) {
    return this.http.post(this.url + 'job/invite_company_recruiter', data, { headers });
  }
  companyAccRej(data: any) {
    return this.http.post(this.url + 'company_list/recruiter_acp_rej', data, { headers });
  }
  visaDetail(data: any) {
    return this.http.post(this.url + 'manage_visa/get_profile', data, { headers });
  }
  submitVisa(data: any) {
    return this.http.post(this.url + 'manage_visa', data, { headers });
  }
  acceptRejectVisa(data: any) {
    return this.http.post(this.url + 'manage_visa/visa_acp_rej', data, { headers });
  }
  // Category / Sub category
  getCategoryList(data) {
    return this.http.get(this.url + 'job/get_job_category', { headers });
  }
  // Export schedule Url
  exportSchedule(data) {
    return this.http.post(this.url + 'report/create_shit_report', data, { headers });
  }

  getExpList(data: any) {
    return this.http.post(this.expUrl + '/get_experience', data, { headers })
  }
  addExp(data: any) {
    return this.http.post(this.expUrl, data, { headers })
  }
  editExp(data: any) {
    return this.http.post(this.expUrl + '/edit_experience', data, { headers })
  }
  deleteExp(data: any) {
    return this.http.post(this.expUrl + '/remove_experience', data, { headers })
  }
  getBankList(data: any) {
    return this.http.post(this.bankUrl + 'get_bank', data, { headers })
  }
  addBank(data: any) {
    return this.http.post(this.bankUrl, data, { headers })
  }
  editBank(data: any) {
    return this.http.post(this.bankUrl + 'edit_bank_details', data, { headers })
  }
  deleteBank(data: any) {
    return this.http.post(this.bankUrl + 'remove_bank', data, { headers })
  }
  getEmpBankDetails(data: any) {
    return this.http.post(this.bankUrl + 'get_bank', data, { headers })
  }
  getProfileList(data: any) {
    return this.http.post(this.profileUrl + 'get_job_profile', data, { headers })
  }
  addProfile(data: any) {
    return this.http.post(this.profileUrl, data, { headers })
  }
  viewProfile(data: any) {
    return this.http.post(this.profileUrl + 'specific_profile', data, { headers })
  }
  deleteProfile(data: any) {
    return this.http.post(this.profileUrl + 'remove_job_profile', data, { headers })
  }
  roleAccRej(data: any) {
    return this.http.post(this.profileUrl + 'accept_reject_role', data, { headers })
  }
  sendNotification(data: any) {
    return this.http.post(this.url + 'send_notification_employee', data, { headers });
  }
  shareSignUpLink(data: any) {
    return this.http.get(this.url + 'referral_code', { headers });
  }
  companySignDoc(id) {
    return this.http.get(this.url + 'contract_document/company_sign_contract?document_id=' + id, { headers })
  }

  getNotes(data) {
    return this.http.post(this.notesUrl + 'get_notes', data, { headers });
  }
  deleteNotes(data) {
    return this.http.post(this.notesUrl + 'remove_notes', data, { headers });
  }
  addNotes(data) {
    return this.http.post(this.notesUrl + 'add_notes', data, { headers });
  }
  editNotes(data) {
    return this.http.post(this.notesUrl + 'edit_notes', data, { headers });
  }
  getNoteDetail(data) {
    return this.http.post(this.notesUrl + 'get_specific_notes', data, { headers });
  }
  //=============================category
  getJobCategories(data) {
    return this.http.post(this.categoryUrl + '/get_category_data', data, { headers });
  }
  addJobCategory(data) {
    return this.http.post(this.categoryUrl, data, { headers });
  }
  editJobCategory(data) {
    return this.http.post(this.categoryUrl + '/edit_jc', data, { headers });
  }
  saveWages(data) {
    return this.http.post(this.categoryUrl + '/edit_jsc', data, { headers });
  }
  deleteCategory(data) {
    return this.http.post(this.categoryUrl + '/delete_category', data, { headers });
  }
  deleteSubCategory(data) {
    return this.http.post(this.categoryUrl + '/delete_subcategory', data, { headers });
  }
  // =============visa rule
  addVisaRule(data) {
    return this.http.post(this.visaUrl + 'company_visa_rule', data, { headers });
  }
  getVisaRule(data) {
    return this.http.post(this.visaUrl + 'company_visa_rule_get', data, { headers });
  }

  getReplacementRequestList(data) {
    return this.http.post(this.replacementUrl + '/company_get_replacement_request', data, { headers });
  }
  getReplacementRequestListDateWise(data) {
    return this.http.post(this.replacementUrl + '/company_get_replacement_date_wise', data, { headers });
  }

  replacementRequestApproveReject(data) {
    return this.http.post(this.replacementUrl + '/employee_accept_replacement_company', data, { headers });
  }
  addRating(data) {
    return this.http.post(this.url + 'rating/edit_rating', data, { headers });
  }
  costCalculator(data) {
    return this.http.post(this.url + 'report/cost_calculater', data, { headers })
  }
  onChangeEmpSalried(data) {
    return this.http.post(this.jobAccept + 'emp_salaried', data, { headers })
  }
  onAcceptAllUserForSpecificJob(data) {
    return this.http.post(this.jobAccept + 'company_approve_all', data, { headers })
  }
  timesheetReport(data) {
    return this.http.post(this.report + 'download_timesheet', data, { headers })
  }
  shiftReport(data) {
    return this.http.post(this.report + 'create_shit_report', data, { headers })
  }

  addToFavorite(data) {
    return this.http.post(this.empFavorite + 'edit_favourite', data, { headers })
  }
  // addToFavorite(data) {
  //   return this.http.post(this.jobAccept + 'add_emp_favourite', data, { headers })
  // }

  getUnavailability(data) {
    return this.http.post(this.url + 'manage_employee_availability/get_unavailability', data, { headers })
  }
  newListView(data) {
    return this.http.post(this.url + 'manage_job_view/new_list_view', data, { headers })
  }
  dateWiseSubcatShift(data) {
    return this.http.post(this.url + 'manage_job_view/date_wise_subcat_shift', data, { headers })
  }

  createNewEvent = (data): any => {
    return this.http.post(this.url + 'manage_event/create_event', data, { headers })
  }
  getAllEventList = (data): any => {
    return this.http.post(this.url + 'manage_event/company_get_list', data, { headers })
  }
  deleteEvent(data: any) {
    return this.http.post(this.manageEvent + 'delete_event', data, { headers })
  }
  getSpecificEventById(data) {
    return this.http.post(this.manageEvent + "company_event_insight", data, { headers });
  }
  getTask(data) {
    return this.http.post(this.manageTask + "company_get_list", data, { headers });
  }
  createTask(data) {
    return this.http.post(this.manageTask + "create_task", data, { headers });
  }
  editBreakTime(data) {
    return this.http.post(this.employeeTimeLog + "change_break_time", data, { headers });
  }
  getConflictList(data) {
    return this.http.post(this.manageConflicts + "get_conflict_list", data, { headers });
  }
  getConflictInsight(data) {
    return this.http.post(this.manageConflicts + "company_conflict_insight", data, { headers });
  }
  deleteConflictInsight(data) {
    return this.http.post(this.manageConflicts + "delete_conflict_insight", data, { headers });
  }
  deleteTask(data: any) {
    return this.http.post(this.manageTask + 'delete_task', data, { headers })
  }

  // [work flow start]
  getWorkFlowList(data) {
    return this.http.post(this.url + "manage_workflow/listing", data, { headers });
  }
  addWorkflow(data) {
    return this.http.post(this.url + "manage_workflow/create", data, { headers });
  }
  editWorkflow = (data): any => {
    return this.http.post(this.url + 'manage_workflow/edit', data, { headers });
  }
  deleteWorkflow(data) {
    return this.http.post(this.url + 'manage_workflow/delete', data, { headers })
  }
  viewWorkflow(data) {
    return this.http.post(this.url + "manage_workflow/workflow_details", data, { headers });
  }
  assignWorkflow(data) {
    return this.http.post(this.url + 'manage_workflow/workflow_assign', data, { headers })
  }
  overallStats(data) {
    return this.http.post(this.url + 'manage_workflow/static_view_workflow', data, { headers })
  }
  employeeWiseStats(data) {
    return this.http.post(this.url + 'manage_workflow/static_view_workflow_answer', data, { headers })
  }
  getAllDocument(data) {
    return this.http.post(this.url + 'manage_document/get_all_document', data, { headers })
  }
  getDressCode(data) {
    return this.http.post(this.url + 'manage_dress_code/get_dress_data', data, { headers })
  }
  createDressCode(data) {
    return this.http.post(this.url + 'manage_dress_code/add_dress_list', data, { headers })
  }
  deleteDressCode(data) {
    return this.http.post(this.url + 'manage_dress_code/remove_dresscode', data, { headers })
  }
  deleteDressLogo(data) {
    return this.http.post(this.url + 'manage_dress_code/remove_logo', data, { headers })
  }
  editDressCode(data) {
    return this.http.post(this.url + 'manage_dress_code/edit_dress_list_data', data, { headers })
  }
  sendSelectedNotification(data) {
    return this.http.post(this.url + 'common_notification/send_notification', data, { headers })
  }
  getAllNotificationListing(data) {
    return this.http.post(this.url + 'common_notification/get_notification_list', data, { headers });
  }
  deleteMNotification(data) {
    return this.http.post(this.url + 'common_notification/delete_common_notification', data, { headers });
  }
  getSeenNotification(data) {
    return this.http.post(this.url + 'common_notification/get_seen_user_list', data, { headers });
  }
  getUnseenNotification(data) {
    return this.http.post(this.url + 'common_notification/get_unseen_user_list', data, { headers });
  }
  getNotificationChart(data) {
    return this.http.post(this.url + 'common_notification/get_chart_data', data, { headers });
  }
}
